import { createSelector } from 'reselect';
import { SECTION_ACCESS_TYPES } from '../utils/consts';
import { deriveSectionsAccess, getFeatureSections, getNavigationSections } from './navigation';
import getCurrentPath from './routing';
import { getUserData, isUserAdNetwork, normalizeAccountTypeName } from './user';

const READ = 1;
const WRITE = 2;
const READ_WRITE = 3;
const FEATURE_GOALS = 'goals';

const typesMap = {
    read: READ,
    write: WRITE,
    readWrite: READ_WRITE,
};

const LINK_TO_APP_FEATURE_MAP = {
    '/react/link-management': 'manage_links',
};

const GET_ADNETWORK_MAP = () => ({
    '/react/link-management': { permission: READ, isSingleAccessLevel: false },
});

const GET_AGENCY_MAP = accessTypeMap => ({
    '/react/link-management': {
        permission:
            accessTypeMap['/react/link-management'].accessType === SECTION_ACCESS_TYPES.VIEW ? READ : READ_WRITE,
        isSingleAccessLevel: accessTypeMap['/react/link-management'].isSingleAccessLevel,
    },
    '/react/singular-events': { permission: READ, isSingleAccessLevel: false },
});

const ACCOUNT_TYPES_MAP = {
    ad_network: accessTypeMap => GET_ADNETWORK_MAP(accessTypeMap),
    agency_account: accessTypeMap => GET_AGENCY_MAP(accessTypeMap),
};

const getAccessTypeMap = createSelector([getNavigationSections], navigationSections => {
    const accessTypeMap = {};
    for (const [path, appFeatureName] of Object.entries(LINK_TO_APP_FEATURE_MAP)) {
        const sections = getFeatureSections(navigationSections, appFeatureName);
        accessTypeMap[path] = deriveSectionsAccess(sections);
    }
    return accessTypeMap;
});

const getUserMap = createSelector([getUserData, getAccessTypeMap], (userData, accessTypeMap) => {
    const accountType = normalizeAccountTypeName(userData.account_type_name);
    return ACCOUNT_TYPES_MAP[accountType]?.(accessTypeMap) || {};
});

export const getFeaturePermissions = createSelector([getUserMap, getCurrentPath], (userMap, currentPath) => {
    const { permission = READ_WRITE, isSingleAccessLevel = true } = userMap[currentPath.pathname] || {};
    return {
        typesMap,
        permission,
        isSingleAccessLevel,
    };
});

export const isGoalsReportPermitted = createSelector([isUserAdNetwork, getUserData], (isAdNetwork, userData) => {
    return !isAdNetwork && userData.feature_flags?.includes(FEATURE_GOALS);
});
